module.exports = __webpack_public_path__ + "img/ru_img1.42f40bc6.png";